import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';

import {AppService} from '@api';
import {SistemaService} from './Sistema.Service';

import {RespuestaEstatusEnum} from '@enumeraciones/Enumeraciones.enum';
import {MensajeService} from '@mensaje/Mensaje.Service';
import {DialogoEnum, TipoOpcionEnum} from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import {DialogoOpcion} from '@mensaje/Modelo/Dialogo.model';

@Injectable()
export class UsuarioService {
    logeando: boolean = false;

    timerSesion: any;
    sesionFin: any;

    constructor(private appService: AppService, private mensajeService: MensajeService, private sistemaService: SistemaService, public translate: TranslateService, private router: Router) {
        if (localStorage.getItem(this.sistemaService.localStoreVariable.JWT) && !localStorage.getItem(this.sistemaService.localStoreVariable.AOT)) {
            localStorage.removeItem(this.sistemaService.localStoreVariable.JWT);
        }
        this.appService.cerrarSesion.subscribe((url) => {
            if (url && !url.includes("/usuario/cerrarsesion")) {
                this.CerrarSesion();
            }
        });
    }


    CerrarSesion() {
        this.appService.Put("auth/cerrarsesion", null);
        this.CerrarSesionConfirmado();
    }

    CerrarSesionConfirmado() {
        if (this.timerSesion) {
            clearInterval(this.timerSesion);
            this.timerSesion = null;
        }
        this.logeando = false;
        this.sistemaService.LimpiarDatosSesion();
        this.router.navigateByUrl('/inicio');
    }

    CerrarSesionEnmascarado() {
        this.appService.Put("auth/cerrarsesionenmascarado", null).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                window.location.reload();
            }
        })
    }


    LoadPermisos() {
        return new Promise((resolve) => {

            this.appService.Get("inicio/permisos").then(res => {
                //this.sistemaService.permisos = res.data.permisos;
                this.sistemaService.usuario = res.data.usuario;
                this.sistemaService.opcionesMenu = res.data.opcionesmenu;

                this.sistemaService.SetUsuarioMenu();
                this.sistemaService.GetMenuHome();

                this.sistemaService.permisosCargados = true;

                if (this.sistemaService.usuario.usuarioenmascarado) {
                    if (localStorage.getItem(this.sistemaService.localStoreVariable.UsuarioEnmascarado) === "1") {
                        localStorage.removeItem(this.sistemaService.localStoreVariable.UsuarioEnmascarado);
                    }
                    else {
                        let opciones = [];

                        opciones.push(new DialogoOpcion({Titulo: this.sistemaService.usuario.nombreoriginal, Valor: 1, Tipo: TipoOpcionEnum.negativo}));
                        opciones.push(new DialogoOpcion({Titulo: this.sistemaService.usuario.nombre, Valor: 2, Tipo: TipoOpcionEnum.negativo}));
                        var mensaje = this.translate.instant("Perfil.MensajeUsuarioEnmascarado");


                        this.mensajeService.Dialogo(DialogoEnum.aviso, "", mensaje, opciones).then((respuesta: any) => {
                            if (respuesta == 1) {
                                this.CerrarSesionEnmascarado();
                            }
                        });
                    }
                }

                this.sistemaService.usuario.tiempoinactividad = (this.sistemaService.usuario.tiempoinactividad - 1) * 60000;
                this.sistemaService.usuario.tiemposesion = (this.sistemaService.usuario.tiemposesion - 0.5) * 60;
                this.appService.iniciarConteoInactividad.next(1);
                this.SetTiempoSesion();

                return resolve(1);
            }).catch(res => {
                this.sistemaService.opcionesMenu = [];
                this.CerrarSesion()
                return resolve(0);
            })
        });
    }

    // Funciones de sesion
    ReanudarSesion() {
        this.appService.Put("auth/reanudarsesion", null).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                localStorage.removeItem(this.sistemaService.localStoreVariable.SesionValida);
                this.SetTiempoSesion();
            }
            else {
                this.appService.sesionFinalizada.next(true);
            }
        }).catch(err => {
            this.appService.sesionFinalizada.next(true);
        })
    }

    SetTiempoSesion() {
        if (localStorage.getItem(this.sistemaService.localStoreVariable.SesionValida)) {
            var fecha = localStorage.getItem(this.sistemaService.localStoreVariable.SesionValida);
            this.sesionFin = new Date(fecha == null ? "" : fecha);
        }
        else {
            this.sesionFin = new Date();
            this.sesionFin.setSeconds(this.sesionFin.getSeconds() + (this.sistemaService.usuario.tiemposesion));
            localStorage.setItem(this.sistemaService.localStoreVariable.SesionValida, this.sesionFin);
        }

        this.StartTimerSesion();
    }

    StartTimerSesion() {
        this.timerSesion = setInterval(() => {
            var tiempo = this.DifenciaTiempo(this.sesionFin);

            if (tiempo == 0) {
                clearInterval(this.timerSesion);
                this.timerSesion = null;
                this.appService.sesionFinalizada.next(true);
            }

        }, 1000);
    }

    DifenciaTiempo(termina: any) {
        var dateEntered = termina;
        var now = new Date();
        var difference = dateEntered.getTime() - now.getTime();

        if (difference <= 0) {
            clearInterval(this.timerSesion);
            this.timerSesion = null;

            return 0;
        }
        else {
            var segundos = Math.ceil(difference / 1000);

            return segundos;
        }
    }

}
